/**
 * Flattens the attributes object from the auth user, handling both nested and flat structures
 * @param attributes - The attributes object from the auth user
 * @returns A flattened object with all properties at the root level
 */
export function flattenAttributes(attributes) {
  const flattened = {};

  function flattenObject(obj, prefix = '') {
    for (const [key, value] of Object.entries(obj)) {
      const newKey = key;

      if (value && typeof value === 'object' && !Array.isArray(value)) {
        flattenObject(value, newKey);
      } else {
        flattened[newKey] = value;
      }
    }
  }

  flattenObject(attributes);
  return flattened;
}

/**
 * Type guard to check if an object has nested attributes structure
 */
function hasNestedAttributes(obj) {
  return (
    'user_information' in obj ||
    'partner_information' in obj ||
    'payment_information' in obj
  );
}

/**
 * Transforms the auth user object by flattening its attributes
 * @param user - The auth user object
 * @returns The transformed user object with flattened attributes
 */
export function transformAuthUser(user) {
  if (!user) return;
  if (!user?.attributes) return user;

  const attributes = user.attributes;
  const flattenedAttributes = hasNestedAttributes(attributes)
    ? flattenAttributes(attributes)
    : attributes;

  return {
    ...user,
    attributes: flattenedAttributes,
  };
}

export const monthsArr = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const getCurrentMonthRange = () => {
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth(); // 0-11

  const lastMonthIndex = currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;
  const nextMonthIndex = currentMonthIndex === 11 ? 0 : currentMonthIndex + 1;

  return {
    lastMonth: monthsArr[lastMonthIndex],
    currentMonth: monthsArr[currentMonthIndex],
    nextMonth: monthsArr[nextMonthIndex],
  };
};
